import React from 'react';

import UploadIcon from '@atlaskit/icon/glyph/upload';

import { FEATURE_FLAG } from '@qality/common-config';

import { UploadAttButtonStyled } from './TestCaseBoxAttachmentButton.styled';

type Props = {
  onClick: () => void;
  isVisible: boolean;
  isHovered: boolean;
  isInNewStep?: boolean;
};

export default function TestCaseBoxAttachmentButton({
  onClick,
  isVisible,
  isHovered,
  isInNewStep = false,
}: Props): JSX.Element {
  if (!isVisible) {
    return null;
  }

  const getClassName = (className: string): string => {
    return isInNewStep ? `new-${className}` : className;
  };

  return (
    <div className={getClassName('drop-container-button')}>
      <UploadAttButtonStyled
        tabIndex={-1}
        onClick={onClick}
        data-testid='upload-attachment-button'
      >
        <UploadIcon size='small' label='' />
      </UploadAttButtonStyled>

      {isHovered && (
        <span
          className={getClassName('drop-container-message')}
          data-testid='upload-attachment-hint'
        >
          or use drag and drop
          {FEATURE_FLAG.isPremium && ', or click any input and ctrl+v'}
        </span>
      )}
    </div>
  );
}
